import { ChangeDetectorRef, Injectable, Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { Observable } from 'rxjs';

import { isPresent } from '@fcom/utils';
import { CurrencyService } from '@fcom/core';
import { Amount } from '@fcom/dapi';
import { CurrencySettings } from '@fcom/core/services/currency/currency-settings';

/**
 * Asynchronous price pipe that supports localizations.
 * Uses currencyService to get price in localized format.
 *
 */
@Injectable()
@Pipe({
  name: 'finPrice',
  pure: false,
})
export class PricePipe implements OnDestroy, PipeTransform {
  private async: AsyncPipe;
  private cached$: Observable<any>;
  private cachedAmount: string;
  private cachedCurrencyCode: string;

  constructor(
    private ref: ChangeDetectorRef,
    private currencyService: CurrencyService
  ) {
    this.async = new AsyncPipe(this.ref);
  }

  transform(
    amount: Amount,
    roundPrice?: boolean,
    useSymbol?: boolean,
    absoluteValue?: boolean,
    abbreviate?: boolean,
    settings?: CurrencySettings
  ): string {
    if (!isPresent(amount)) {
      return undefined;
    }
    if (this.valueChanged(amount)) {
      this.updatePrice(amount, roundPrice, useSymbol, absoluteValue, abbreviate, settings);
    }

    return this.async.transform(this.cached$);
  }

  ngOnDestroy(): void {
    this.async.ngOnDestroy();
  }

  private valueChanged(amount: Amount): boolean {
    return !this.cached$ || amount.amount !== this.cachedAmount || amount.currencyCode !== this.cachedCurrencyCode;
  }

  private updatePrice(
    amount: Amount,
    roundPrice = false,
    useSymbol = true,
    absoluteValue = false,
    abbreviate = false,
    settings: CurrencySettings = {}
  ): void {
    this.cached$ = this.currencyService.formatPrice(amount, roundPrice, useSymbol, settings, absoluteValue, abbreviate);
    this.cachedAmount = amount.amount;
    this.cachedCurrencyCode = amount.currencyCode;
  }
}
